import { useEffect } from 'react';

// Slide-up bottom sheet scoped to the app's max-w-md column.
export function BottomSheet({
  open,
  onClose,
  children,
}: {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center">
      <div className="absolute inset-0 bg-black/40 anim-fade" onClick={onClose} />
      <div
        className="relative w-full max-w-md rounded-t-[28px] max-h-[88vh] overflow-y-auto no-scrollbar anim-slide"
        style={{
          background: 'var(--background)',
          paddingBottom: 'calc(env(safe-area-inset-bottom) + 16px)',
        }}
      >
        <div className="sticky top-0 z-10 flex justify-center pt-3 pb-2" style={{ background: 'var(--background)' }}>
          <span className="w-10 h-1 rounded-full" style={{ background: 'var(--border)' }} />
        </div>
        {children}
      </div>
    </div>
  );
}
